import { ValidationObserver, ValidationProvider } from "vee-validate";
import { EventLocations } from "@/enums/EventLocations";
import firebase from "firebase";

export default {
    name: "addLocationManagementDialog",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            dialog: false,
            loading: false,
            isAdd: false,
            isUpdate: false,
            isAddWing: false,
            isUpdateWing: false,
            careLevelId: "",
            idLocation: "",
            name: "",
            nameOld: "",
            careLevelIdOld: "",
            type: "",
            eventLocations: EventLocations,
            colorMenu: false,
            isDifferentName: false,
            differentName: '',
            office365Email: null,
            color: '#FFFFFF',
            isColorValid: null,
            key: "",
            isDisplayResidentDetails: false,
            isDisplayResidentDetailsInCommunityTile: false,
            isDefaultWing: false
        }
    },
    computed: {
        facilityId() {
            return this.$store.state.authModule.currentFacility;
        },
        wings() {
            return this.$store.state.eventLocationModule.eventWings;
        },
        careLevels() {
            return this.$store.state.careLevelsModule.careLevels.map(x => {
                const c = x
                c.wings = this.wings.filter(w => c.wingsIds?.includes(w.id)).map(y => y.name)
                return c
            });
        },
        swatchStyle() {
            const style = {
                backgroundColor: this.color || '#FFFFFF',
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderRadius: '100%',
                transition: 'border-radius 200ms ease-in-out'
            }
            return style
        },
        isTypeWing() {
            return this.type === this.eventLocations.Wing;
        } ,
        isTypeRoom() {
            return (this.type === this.eventLocations.Room || this.type === this.eventLocations.Location);
        },
        isEnabledFacilityBookingRoomSetting() {
            return this.$store.state.facilityModule.selectedFacility.isEnableRoomBooking;
        },
        eventLocationsTranslate() {
            const baseTranslations = [
                {
                    title: this.eventLocations.Building,
                    value: this.eventLocations.Building
                },
                {
                    title: this.eventLocations.Location,
                    value: this.eventLocations.Location
                },
                {
                    title: this.eventLocations.Other,
                    value: this.eventLocations.Other
                }
            ];

            if (!this.isAdd && !this.isUpdate) {
                baseTranslations.push({
                    title: this.$t("GeneralTranslations.Wing"),
                    value: this.eventLocations.Wing
                });
            }

            return baseTranslations;
        },
        selectedWingOnResidentFilter() {
            return this.$store.state.residentModule.mainResidentsFilters.wingName || null;
        },
    },
    methods: {
        async submit() {
            this.loading = true;

            if (this.isAdd || this.isAddWing) {
                await this.addEventLocation();
            }

            if (this.isUpdate || this.isUpdateWing) {
                await this.updateEventLocation();
            }

            this.close();
        },
        async addEventLocation() {
            const form: any = {
                name: this.name,
                key: this.key,
                type: this.type,
                facilityId: this.facilityId,
                orgId: this.$store.state.authModule.currentFacilityData.orgId
            };

            if (this.isTypeWing) {
                form.color = this.color;
                form.isDisplayResidentDetails = this.isDisplayResidentDetails;
                form.isDisplayResidentDetailsInCommunityTile = this.isDisplayResidentDetailsInCommunityTile;

                if (this.careLevelId?.length) {
                    form.careLevelName = this.careLevels.find(x => x.id === this.careLevelId)?.name || ''
                    form.careLevelId = this.careLevelId
                }
            }

            if (this.isTypeRoom) {
                form.isDifferentName = this.isDifferentName;

                if (form.isDifferentName) {
                    form.differentName = this.differentName
                    form.office365Email = this.office365Email
                }
            }

            await this.$store.dispatch("addEventLocation", form)
                .then((result) => {

                    const wingId = result.id

                    if (form.type === EventLocations.Wing && form?.careLevelId?.length) {
                        this.addWingToCareLavel(form.careLevelId, wingId)
                    }

                    if(this.isAddWing || this.isUpdateWing) {
                       this.$store.dispatch("getEventWings")
                    }

                    this.$toast.open({
                        message: `Location successfully added`,
                        type: "success"
                    });
                }).catch((error) => {
                    this.$toast.open({
                        message: `${error.message}`,
                        type: "error"
                    });
                });
        },
        async addWingToCareLavel(careLevelId: string, wingId: string) {

            if (!this.isTypeWing) return

            const careLevelSnap = await firebase.firestore().collection("careLevels").doc(careLevelId).get()

            if (careLevelSnap.exists) {
                const careLevel = careLevelSnap.data()
                if (!careLevel?.wingsIds?.includes(wingId)) {
                    await careLevelSnap.ref.update({
                        wingsIds: firebase.firestore.FieldValue.arrayUnion(wingId),
                    })
                    await this.$store.dispatch("getCareLevels")
                }
            }
        },
        async updateEventLocation() {
            const form: any = {
                id: this.idLocation,
                name: this.name,
                key: this.key,
                type: this.type,
                careLevelId: this.careLevelId,
                careLevelName: this.careLevels.find(x => x.id === this.careLevelId)?.name || null,
            }

            if (this.isTypeWing) {
                form.color = this.color;
                form.isDisplayResidentDetails = this.isDisplayResidentDetails;
                form.isDisplayResidentDetailsInCommunityTile = this.isDisplayResidentDetailsInCommunityTile;
            } else {
                form.careLevelId = null
                form.careLevelName = null
            }

            if (this.isTypeRoom) {
                form.isDifferentName = this.isDifferentName;

                if (form.isDifferentName) {
                    form.differentName = this.differentName
                    form.office365Email = this.office365Email
                }
            }

            await this.$store.dispatch("updateEventLocation", form)
                .then(async () => {

                    await this.changeLocationsOnEvents();

                    await this.changeLocationsOnResidents(form);

                    await this.$store.dispatch("getCareLevels");

                    await this.changeWingOnCareLevel(form)

                    if (this.selectedWingOnResidentFilter === this.nameOld) {
                        this.$store.commit("setMainResidentsFilters", { wingName: this.name });
                    }

                    if(this.isAddWing || this.isUpdateWing) {
                        this.$store.dispatch("getEventWings")
                    }

                    this.$toast.open({
                        message: this.$i18n.messages[this.$i18n.locale]['LocationManagement.LocationSuccessfullyUpdated'],
                        type: "success"
                    });

                }).catch((error) => {
                    this.$toast.open({
                        message: `${error.message}`,
                        type: "error"
                    });
                });
        },
        async changeLocationsOnEvents() {
            if (this.type !== EventLocations.Wing) {
                await firebase
                    .firestore()
                    .collection("calender")
                    .where("facilityId", "==", this.facilityId)
                    .where("location", "==", this.nameOld)
                    .get()
                    .then((querySnapshot) => {
                        if (querySnapshot.docs && querySnapshot.docs.length) {
                            querySnapshot.docs.forEach((item) => {
                                console.log(item.data())
                                item.ref.update({
                                    'location': this.name
                                })
                            })
                        }
                    })
            }

            if (this.type === EventLocations.Wing) {
                await firebase
                    .firestore()
                    .collection("calender")
                    .where("facilityId", "==", this.facilityId)
                    .where("wing", "==", this.nameOld)
                    .get()
                    .then((querySnapshot) => {
                        if (querySnapshot.docs && querySnapshot.docs.length) {
                            querySnapshot.docs.forEach((item) => {
                                console.log(item.data())
                                item.ref.update({
                                    'wing': this.name
                                })
                            })
                        }
                    })
            }
        },
        async changeLocationsOnResidents(wing: any) {
            if (this.type === EventLocations.Wing) {
                await firebase
                    .firestore()
                    .collection("residents")
                    .where("facilityId", "==", this.facilityId)
                    .where("wingId", "==", wing.id)
                    .get()
                    .then((querySnapshot) => {
                        if (querySnapshot.docs && querySnapshot.docs.length) {
                            querySnapshot.docs.forEach((item) => {
                                item.ref.update({
                                    'wingName': this.name
                                })
                            })
                        }
                    })
            }
        },
        async changeWingOnCareLevel(form) {
            try {
                if (this.type === EventLocations.Wing && this.careLevelIdOld !== form.careLevelId) {

                    const careLevelOld = this.careLevelIdOld? await firebase.firestore().collection("careLevels").doc(this.careLevelIdOld).get() : null;

                    if (careLevelOld?.exists) {
                        await careLevelOld.ref.update({
                            wingsIds: firebase.firestore.FieldValue.arrayRemove(form.id)
                        })
                    }

                    const careLevelNew = form.careLevelId? await firebase.firestore().collection("careLevels").doc(form.careLevelId).get(): null;

                    if (careLevelNew?.exists) {
                        await careLevelNew.ref.update({
                            wingsIds: firebase.firestore.FieldValue.arrayUnion(form.id)
                        })
                    }

                    await this.$store.dispatch("getCareLevels");
                }

            } catch (error) {
                console.error("Error updating careLevels:", error);
            }
        },
        open(type, location) {
            this.dialog = true;

            this.$store.dispatch("getEventWings");
            this.$store.dispatch("getCareLevels")

            if (type === "addLocation") {
                this.isAdd = true;
            }

            if (type === "updateLocation") {
                this.isUpdate = true;
                this.careLevelId = location?.careLevelId || null;
                this.idLocation = location.id;
                this.name = location.name;
                this.nameOld = location.name;
                this.key = location.key || "";
                this.careLevelIdOld = location?.careLevelId || null;
                this.type = location.type;
                this.color = location?.color ?? '#FFFFFF';
                this.isDifferentName = location?.isDifferentName || false;
                this.differentName = location?.differentName || '';
                this.office365Email = location?.office365Email || null;
            }

            if(type === "addWing") {
                this.isAddWing = true;
                this.type = this.eventLocationsTranslate.find(x => x.value === this.eventLocations.Wing).value;
            }

            if(type === "updateWing") {
                this.isUpdateWing = true;
                this.careLevelId = location?.careLevelId || null;
                this.idLocation = location.id;
                this.name = location.name;
                this.nameOld = location.name;
                this.key = location.key || "";
                this.careLevelIdOld = location?.careLevelId || null;
                this.type = location.type;
                this.color = location?.color ?? '#FFFFFF';
                this.isDifferentName = location?.isDifferentName || false;
                this.differentName = location?.differentName || '';
                this.office365Email = location?.office365Email || null;
                this.isDisplayResidentDetails = location?.isDisplayResidentDetails || false;
                this.isDisplayResidentDetailsInCommunityTile = location?.isDisplayResidentDetailsInCommunityTile || false;
                this.isDefaultWing = location?.isDefault || false;
            }
        },
        close() {
            this.loading = false;
            this.dialog = false;
            this.isAdd = false;
            this.isUpdate = false;
            this.isAddWing = false;
            this.isUpdateWing = false;
            this.isDifferentName = false;
            this.differentName = '';
            this.office365Email = null;
            this.name = "";
            this.key = "";
            this.type = "";
            this.careLevelId = "";
            this.color = "#FFFFFF";
            this.isDisplayResidentDetails = false;
            this.isDisplayResidentDetailsInCommunityTile = false;
            this.isDefaultWing = false;
            this.$refs.observer.reset();
        },
        setCategoryColor(event) {
            this.color = event.hex || event;

            this.validateColor(this.color)
        },
        validateColor(color) {
            this.isColorValid = !(!color || color === '#FFFFFF');

            return this.isColorValid
        }
    }
}
